import { StyleSheet, Dimensions, Platform } from 'react-native';

const { width: screenWidth } = Dimensions.get('window');

export default StyleSheet.create({
  containerStyle: {
    width: '100vw',
    position: 'absolute',
  },
  lottieViewStyles: theme => ({
    bottom: 0,
    alignSelf: 'center',
    position: 'absolute',
    shadowColor: theme.colors.shadowColor,
    shadowOffset: { height: 2 },
    shadowOpacity: 0.5,
    shadowRadius: 5,
    width: screenWidth + 100,
    height: 85,
    marginBottom: -5,
    filter: 'drop-shadow(rgba(2, 0, 0, 0.7) 0px 2px 2px)'
    // background: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(164,164,164,0.4822303921568627) 44%, rgba(108,108,108,0.6026785714285714) 100%);',
    // 'background-size': '100% 80px',
    // 'background-repeat': 'no-repeat'
  }),
});
